module.exports = __webpack_public_path__ + "45722a10f2aeb9e38f80182af5848827.png";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/content/images/background_jyogui-logo.png
// module id = 120
// module chunks = 0